/**
 * useStudentRealizationsState — les gestes des « Activités faites » de l'élève.
 *
 * La fermeture et la recherche sont celles du parent (`useRealizationsState`, lu tel quel : même
 * croix, `goBack` sinon `menu`, comme `RealizationsTabScreen.js:136-142`). L'élève y ajoute :
 * - toucher une ligne rouvre l'activité terminée (`useOpenFinishedStudentActivity`) — le parent,
 *   lui, ouvre sa fiche ;
 * - les deux boutons de la carte d'offre (`BecomePremiumCard.js`) : « Essai gratuit » pousse
 *   `start-trial` (`:61-66`, l'élève `basic` peut toujours démarrer l'essai), « Une question ? »
 *   écrit au support (`mailto:`, `:133-138`) — l'élève n'a pas de chat de support dans son espace.
 */
import { useNavigation } from "@react-navigation/native"
import { useMemo } from "react"

import { useRealizationsState } from "../../parent/Activities/useRealizationsState"
import { useOpenFinishedStudentActivity } from "./useOpenFinishedStudentActivity"
import { openSupportEmail } from "../../../hooks/openSupportEmail"

type PushNavigation = { push: (route: string, params?: object) => void }

export function useStudentRealizationsState() {
    const navigation = useNavigation() as unknown as PushNavigation
    const { search, actions: listActions } = useRealizationsState()
    const openFinished = useOpenFinishedStudentActivity()

    const actions = useMemo(
        () => ({
            ...listActions,
            openActivity: openFinished,
            startTrial: () => navigation.push("start-trial"),
            askQuestion: openSupportEmail,
        }),
        [listActions, navigation, openFinished]
    )

    return { search, actions }
}
